var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_1425_1986)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1425_1986",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1425_1986",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1425_1986",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABIUlEQVR4nO3dsWmjURSE0deUIiPj/nNVoYX5XcEsTpw60jJmz8Bp4H4F3HPMzMzMzMzMzMzMzMzMzL7X93Pr2/ngvN77uf0c5H4evZ9y/oWHIPcpgnSLIN0iSLcI0i2CdIsg3SJItwjSLYJ0iyDdIki3CNItgnSLIN0iSLcI0i2CdIsg3SJItwjSLYJ0iyDdIki3CNItgnSLIN0iSLcI0i2C9LcFeeZ6/Mln+Xy5r1sLkh2CZIsg2SJItgiSLYJkiyDZIki2CJItgmSLINkiSLYIki2CZIsg2SJItgiSLYJkiyDZIki2CJItgmSLINkiSLYIki2CZIsg2SJItgiSLYLkNwa5rtsz+SCvd10/v6swMzMzMzMzMzMzMzMzs/P/7C9y+Kjzt3oygwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.0062216a1eedb260a3f978e49e9dc711.svg";
export { ForwardRef as ReactComponent };